import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../api';
import { AppState } from '../../store/models/app-state';
import { Customer } from '../models/customer';

export const RECEIVE_CUSTOMER = 'RECEIVE_CUSTOMER';
export const RECEIVE_CUSTOMERS = 'RECEIVE_CUSTOMERS';
export const RECEIVE_DEMAND_CUSTOMERS = 'RECEIVE_DEMAND_CUSTOMERS';
export const REQUEST_CUSTOMER = 'REQUEST_CUSTOMER';
export const REQUEST_CUSTOMERS = 'REQUEST_CUSTOMERS';
export const REQUEST_DEMAND_CUSTOMERS = 'REQUEST_DEMAND_CUSTOMERS';
export const RESET_CUSTOMER = 'RESET_CUSTOMER';

const requestCustomer = () => {
    return {
        type: REQUEST_CUSTOMER,
    };
};

const receiveCustomer = (customer: Customer) => {
    return {
        type: RECEIVE_CUSTOMER,
        customer,
    };
};

export const resetCustomer = () => {
    return {
        type: RESET_CUSTOMER,
    };
};

export const fetchCustomer = (id: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(requestCustomer());
        const response = await api.customer.get(id);

        if (response.success) {
            dispatch(receiveCustomer(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
